import React from 'react'
import {
  Container,
  Header,
} from 'semantic-ui-react'
import {
  withRouter
} from 'react-router'
import SelectionButtonGroup from './SelectionButtonGroup.js'
import SelectionSettingsForm from './SelectionSettingsForm.js'
import SelectionDoesNotExist from './SelectionDoesNotExist.js'
import DeleteSelectionPane from './DeleteSelectionPane.js'

const SelectionSettings = ({match, history, mode, selections, typePresets, onUpdate, onDelete}) => {
  const selection = selections.find(s=>s.id===match.params.selectionName);
  if (!selection) {
    return <SelectionDoesNotExist id={match.params.selectionName}/>;
  }
  return (
    <Container text style={{ marginTop: '7em', padding: '10px', background: 'white #fef0e7' }}>
      <Header as='h1' style={{color: '#f2711c'}}>
        <SelectionButtonGroup id={selection.id}/>
        <Header.Subheader style={{color: '#f7a56e'}}>Change Settings</Header.Subheader>
        {selection.name} <span style={{fontWeight: 'lighter', fontVariant: 'all-small-caps'}}>({selection.id})</span>
      </Header>
      <SelectionSettingsForm
        selections={selections}
        selection={selection}
        onSubmit={(id,s)=>{onUpdate(id,s); history.push('/selections')}}
        submitButtonName='Update'
        typePresets={typePresets}
      />
      <DeleteSelectionPane selection={selection} onDelete={onDelete}/>
    </Container>
  );
}

export default withRouter(SelectionSettings)